export default "__VITE_ASSET__CxwSkobZ__"